<template>
  <div class="rules">
    <accordion-component/>
    <div class="rules__img">
      <img src="../../src/assets/images/rules/rules-img.png" alt="">
    </div>
  </div>
</template>

<script>
  import AccordionComponent from "@/components/accordeon-componente.vue"
  export default {
    components: {
      AccordionComponent,
    }
  }
</script>

<style>

</style>